export default __webpack_public_path__ + "static/media/noun_oral orthodontics_1945577.068828bd.png";